import * as v from "valibot";
import { baseVals, defineRecordSchema, defineValidation } from "../../common/validation.common";
import { SubscriptionProductChangeStatusEnum } from "../../data/enums";

export namespace SubscriptionProductChangeValidation {
    export const Record = defineValidation(
        defineRecordSchema({
            filters: v.object({
                status: v.optional(v.array(v.picklist(SubscriptionProductChangeStatusEnum.values))),
            }),
        }),
    );

    export const Create = defineValidation(
        v.object({
            customerId: baseVals.string(),
            subscriptionId: baseVals.string(),
            toProductId: baseVals.string(),
        }),
    );
}
